/**
 * 教师端主题应用引擎（独立拷贝，不依赖学生端任何文件）
 * ============================================================
 * 职责：解析目标主题 → 把 token 写入 :root 的 --th-* CSS 变量
 *       → 切换 body 的 theme-th-* class → 品牌信息写入 document.title。
 *
 * 未来接入后台下发换皮时，只替换 resolveTeacherTheme 的数据来源，
 * 变量注入与 class 切换逻辑不变；皮肤层 teacher-theme.css 无需改动。
 */
import { TEACHER_THEME_CONFIG, ALL_THEME_CLASSES } from './teacherThemeConfig'

/** hex → 'r, g, b' 三元组（供 CSS 里 rgba(var(--th-primary-rgb), α) 派生透明色） */
function hexToRgbTriplet(hex) {
	const v = String(hex).replace('#', '');
	const full = v.length === 3 ? v.split('').map(c => c + c).join('') : v;
	const n = parseInt(full, 16);
	return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
}

/**
 * 按路由解析目标主题（先到先得：corpId 精确匹配 > 默认主题）。
 * routes 当前为空数组，命中逻辑随后台下发一并启用。
 */
function resolveTeacherTheme() {
	const config = TEACHER_THEME_CONFIG;
	return config.themes[config.defaultTheme];
}

/** 把主题应用到页面：token → CSS 变量 + body class + 品牌 */
export function applyTeacherTheme() {
	const theme = resolveTeacherTheme();
	const tokens = Object.assign({}, theme.tokens);

	/* RGB 三元组缺省时由主色现算，token 只需配置 hex 一份 */
	if (!tokens.primaryRgb && tokens.primary) tokens.primaryRgb = hexToRgbTriplet(tokens.primary);
	if (!tokens.accentRgb && tokens.accent) tokens.accentRgb = hexToRgbTriplet(tokens.accent);

	const root = document.documentElement;
	Object.keys(tokens).forEach(key => {
		root.style.setProperty(`--th-${key}`, tokens[key]);
	});

	/* 先清全部主题 class 再挂当前主题，防多主题叠加 */
	ALL_THEME_CLASSES.forEach(cls => document.body.classList.remove(cls));
	if (theme.themeClass) document.body.classList.add(theme.themeClass);

	if (theme.brand && theme.brand.productName) {
		document.title = theme.brand.productName;
	}
	return theme;
}
